var React = require('react');

function IconMenu (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 74.1h100v11.1H0z","key":0}),React.createElement("path",{"d":"M0 14.8h100v11.1H0z","key":1}),React.createElement("path",{"d":"M0 44.4h100v11.1H0z","key":2})]);
}

IconMenu.defaultProps = {"className":"icon menu","viewBox":"0 0 100 100"};

module.exports = IconMenu;

IconMenu.default = IconMenu;



//////////////////
// WEBPACK FOOTER
// ./src/media/icon-menu.svg
// module id = 526
// module chunks = 0